__turbopack_context__.v({
  "radioGroupContainer": "questionAlertsTypeSwitcher-module-scss-module__komWyq__radioGroupContainer",
  "radioItemWrp": "questionAlertsTypeSwitcher-module-scss-module__komWyq__radioItemWrp",
});
